export default "/packs/images/map~ee9882bc2f3b239afbf591ee7a92aa19.png";